export const PropertyTabsNav = () => {

    return (

        <ul className="nav nav-pills mb-2">
            <li className="nav-item">
                <a href="#nav-pills-tab-details" data-bs-toggle="tab" className="nav-link active">
                    <span className="d-sm-none">Details</span>
                    <span className="d-sm-block d-none">Details</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-tenants" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Tenants</span>
                    <span className="d-sm-block d-none">Tenants</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-rooms" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Rooms</span>
                    <span className="d-sm-block d-none">Rooms</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-inspections" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Inspections</span>
                    <span className="d-sm-block d-none">Inspections</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-gallery" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Photo Gallery</span>
                    <span className="d-sm-block d-none">Photo Gallery</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-notes" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Notes</span>
                    <span className="d-sm-block d-none">Notes</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-maintenance" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Maintenance</span>
                    <span className="d-sm-block d-none">Maintenance</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-documents" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Documents</span>
                    <span className="d-sm-block d-none">Documents</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-keycodes" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Key Codes</span>
                    <span className="d-sm-block d-none">Key Codes</span>
                </a>
            </li>
            <li className="nav-item">
                <a href="#nav-pills-tab-brochure" data-bs-toggle="tab" className="nav-link">
                    <span className="d-sm-none">Brochure</span>
                    <span className="d-sm-block d-none">Brochure</span>
                </a>
            </li>
        </ul>

    );

}